import { useEffect } from 'react';
import { usePaymentProviderContext } from '../../Session';
import { ModuleConfiguration } from './types';

export const useRequirePaymentProvider = (requires: ModuleConfiguration['requires']) => {
  const { isLoading, paymentProvider } = usePaymentProviderContext();
  const noPaymentProvider = requires?.paymentProvider && !isLoading && !paymentProvider;

  useEffect(() => {
    if (noPaymentProvider) {
      console.info('user has no payment provider');
      window.location.assign(new URL('/account#!/upload', window.location.origin));
    }
  }, [noPaymentProvider]);
};
